import { ProfileService } from './../../../../../services/profile/profile.service';
import { PermissionService } from './../../../../../util/services/permission/permission.service';
import { NotificationService } from './../../../../../services/notification/notification.service';
import { LabelsService } from './../../../../../util/services/labels/labels.service';
import { ApproversGroupService } from './service/approvers-group.service';
import { Component, OnInit } from '@angular/core';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { solutionAreaInterface } from 'src/app/util/interfaces/requestClassification';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

export interface groupApprovalIntarface {
	id?: string | number;
	group?: string;
	conector?: string;
}
@Component({
	selector: 'register-form-approvers-group',
	templateUrl: './approvers-group.component.html',
	styleUrls: ['./approvers-group.component.scss'],
})
export class ApproversGroupComponent implements OnInit {
	icons = {
		faInfoCircle: faInfoCircle,
	};

	labels: any = {
		lbl_grupo_aprovadores: '',
		lbl_atualizar_aprovadores: '',
		lbl_geral_aprovadores: '',
		lbl_geral_selecione: '',
		lbl_geral_sel_grupo: '',
		lbl_geral_grupo: '',
		lbl_regra_aprovacao: '',
		lbl_apenas_aprovacao: '',
		lbl_todos_devem_aprovar: '',
		lbl_successful_updated: '',
		lbl_selecione_regra_aprovacao: '',
		lbl_geral_voltar: 'Back',
		lbl_geral_editar: 'Edit',
		lbl_geral_clientes: 'Customers',
	};

	isLoadingLabels = true;
	isLoadingSolutionAreas = true;
	isLoadingCustomers = true;
	isLoadingApproversGroups = true;
	isLoadingAvailableAnalysts = true;
	isLoadingApproversGroupInfo = true;
	isUpdatingApprovers = false;

	showTableGroup = true;
	showNewGroup = false;
	showEditGroup = false;

	selectedApproverGroup = '';
	selectedApproverGroupObject: { name: string; value: string; secondName?: string };

	iacAvailableApproversGroup: iacOptionInterface[] = [];

	availableAnalystsForm: genericFormInterface[] = [
		{
			name: 'analysts',
			label: 'lbl_geral_aprovadores',
			inputType: 'multi-select',
			values: [],
			outItems: [],
			items: [],
			filterItem: [''],
			filterValues: [''],
			rawValues: [''],
		},
	];

	availableSolutionAreaForm: genericFormInterface[] = [
		{
			name: 'solutionArea',
			label: 'lbl_geral_grupo',
			inputType: 'multi-select',
			values: [],
			outItems: [],
			items: [],
			filterItem: [''],
			filterValues: [''],
			rawValues: [''],
			extraFunction: () => {
				this.selectedSolutionAreas = [];
				for (const e of this.availableSolutionAreaForm[0].values) {
					this.selectedSolutionAreas.push(e.values);
				}
				this.getAvailableAnalysts(this.selectedApproverGroupObject.value, this.selectedCustomers, this.selectedSolutionAreas);
			},
		},
	];

	availableCustomersForm: genericFormInterface[] = [
		{
			name: 'customers',
			label: 'lbl_geral_clientes',
			inputType: 'multi-select',
			values: [],
			outItems: [],
			items: [],
			filterItem: [''],
			filterValues: [''],
			rawValues: [''],
			extraFunction: () => {
				this.selectedCustomers = [];
				for (const e of this.availableCustomersForm[0].values) {
					this.selectedCustomers.push(e.values);
				}
				this.getAllSolutionAreas(this.selectedApproverGroupObject.value, this.selectedCustomers);
			},
		},
	];

	selectedAnalysts: string[] = [];
	selectedSolutionAreas: string[] = [];
	selectedCustomers: string[] = [];
	solutionAreaList: solutionAreaInterface[] = [];
	groupApprovalsList: groupApprovalIntarface[] = [];
	groupSelectedConector: string;

	searchHeader: mspTableHeaderI[] = [{ name: 'name', value: 'lbl_grupo_aprovadores', colType: 'text' }];

	groupApprovalIntarface: groupApprovalIntarface = {
		id: undefined,
		group: '',
		conector: '',
	};

	constructor(
		private ApproversGroupService: ApproversGroupService,
		private LabelsService: LabelsService,
		public NotificationService: NotificationService,
		public PermissionService: PermissionService,
		public ProfileService: ProfileService
	) {}

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.getApproversGroup();
		this.getAllGroupApproval();
	}

	getAllSolutionAreas(idApproverGroup: string, customersList: string[]): void {
		this.isLoadingSolutionAreas = true;

		this.availableSolutionAreaForm[0].items = [];
		this.availableSolutionAreaForm[0].values = [];
		this.availableSolutionAreaForm[0].rawValues = [];
		this.selectedSolutionAreas = [];

		this.ApproversGroupService.getAllSolutionAreas(idApproverGroup, customersList).subscribe((solutionAreas) => {
			for (const e of solutionAreas[0].items) {
				const newItem: genericFormInterface['items'][number] = {
					name: e.name,
					label: e.name,
					value: e.name,
					values: e.values,
				};
				this.availableSolutionAreaForm[0].items.push(newItem);
			}

			for (const e of solutionAreas[0].values) {
				const newItem: genericFormInterface['items'][number] = {
					name: e.name,
					label: e.name,
					value: e.name,
					values: e.values,
				};

				this.availableSolutionAreaForm[0].items.push(newItem);
				this.availableSolutionAreaForm[0].values.push(newItem);
				this.availableSolutionAreaForm[0].rawValues.push(newItem.values);
				this.selectedSolutionAreas.push(newItem.values);
			}

			this.isLoadingSolutionAreas = false;
		});
	}

	getAllCustomers(idApproverGroup: string): void {
		this.isLoadingCustomers = true;

		this.availableCustomersForm[0].items = [];
		this.availableCustomersForm[0].values = [];
		this.availableCustomersForm[0].rawValues = [];
		this.selectedCustomers = [];

		this.ApproversGroupService.getAllCustomers(idApproverGroup)
			.subscribe((customers) => {
				for (const e of customers[0].items) {
					const newItem: genericFormInterface['items'][number] = {
						name: e.name,
						label: e.name,
						value: e.name,
						values: e.values,
					};
					this.availableCustomersForm[0].items.push(newItem);
				}

				for (const e of customers[0].values) {
					const newItem: genericFormInterface['items'][number] = {
						name: e.name,
						label: e.name,
						value: e.name,
						values: e.values,
					};

					this.availableCustomersForm[0].items.push(newItem);
					this.availableCustomersForm[0].values.push(newItem);
					this.availableCustomersForm[0].rawValues.push(newItem.values);
					this.selectedCustomers.push(newItem.values);
				}

				this.isLoadingCustomers = false;
			})
			.add(() => {
				this.getAllSolutionAreas(idApproverGroup, this.selectedCustomers);
				this.getAvailableAnalysts(idApproverGroup, this.selectedCustomers, this.selectedSolutionAreas);
				this.isLoadingApproversGroupInfo = false;
			});
	}

	getAllGroupApproval(): void {
		this.ApproversGroupService.getGroupApproval().subscribe((data) => {
			this.groupApprovalsList = data;
		});
	}

	getApproversGroupInfo(approverGroupName: string) {
		this.selectedApproverGroup = approverGroupName;
		this.showTableGroup = false;
		this.showNewGroup = false;
		this.isLoadingApproversGroupInfo = true;

		this.selectedApproverGroupObject = this.iacAvailableApproversGroup.find((element) => element.name === this.selectedApproverGroup);
		if (this.selectedApproverGroupObject) {
			const idApproverGroup = this.selectedApproverGroupObject.value;
			this.groupSelectedConector = this.selectedApproverGroupObject.secondName;

			this.getAllCustomers(idApproverGroup);
		}
	}

	getApproversGroup() {
		this.iacAvailableApproversGroup = [];
		this.ApproversGroupService.getApproversGroup().subscribe((approversGroups) => {
			for (const e of approversGroups) this.iacAvailableApproversGroup.push(e);
		});
		this.isLoadingSolutionAreas = false;
	}

	getAvailableAnalysts(idGroupApprovers: string, customersList: string[], solutionAreasList: string[]) {
		this.isLoadingAvailableAnalysts = true;

		this.availableAnalystsForm[0].items = [];
		this.availableAnalystsForm[0].values = [];
		this.availableAnalystsForm[0].rawValues = [];

		this.ApproversGroupService.getAnalystsApprovers(idGroupApprovers, customersList, solutionAreasList).subscribe((analysts) => {
			for (const e of analysts[0].items) {
				const newItem: genericFormInterface['items'][number] = {
					name: e.name,
					label: e.name,
					value: e.name,
					values: e.values,
				};
				this.availableAnalystsForm[0].items.push(newItem);
			}

			for (const e of analysts[0].values) {
				const newItem: genericFormInterface['items'][number] = {
					name: e.name,
					label: e.name,
					value: e.name,
					values: e.values,
				};

				this.availableAnalystsForm[0].items.push(newItem);
				this.availableAnalystsForm[0].values.push(newItem);
				this.availableAnalystsForm[0].rawValues.push(newItem.values);
				this.selectedSolutionAreas.push(newItem.values);
			}
		});

		this.isLoadingAvailableAnalysts = false;
	}

	updateApproversGroup() {
		this.isUpdatingApprovers = true;
		this.selectedAnalysts = [];
		this.selectedSolutionAreas = [];
		this.selectedCustomers = [];

		for (const e of this.availableAnalystsForm[0].values) {
			this.selectedAnalysts.push(e.values);
		}

		for (const e of this.availableSolutionAreaForm[0].values) {
			this.selectedSolutionAreas.push(e.values);
		}

		for (const e of this.availableCustomersForm[0].values) {
			this.selectedCustomers.push(e.values);
		}
		if (this.groupSelectedConector === '') {
			this.NotificationService.setNotificationMessage(this.labels.lbl_selecione_regra_aprovacao);
			this.isUpdatingApprovers = false;
			return;
		}

		this.ApproversGroupService.putTaskApprover(
			this.selectedApproverGroupObject.value,
			this.selectedAnalysts,
			this.selectedSolutionAreas,
			this.selectedCustomers,
			this.groupSelectedConector
		).subscribe((res) => {
			if (res[0].status === 'Ok') {
				this.isUpdatingApprovers = false;
				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
			}
		});
	}

	clearInputs(isNew: boolean): void {
		this.isLoadingApproversGroups = true;
		this.showTableGroup = isNew;
		setTimeout(() => {
			this.isLoadingApproversGroups = false;
		}, 10);
	}

	validateForm(): any {
		if (this.groupApprovalIntarface.group === '' || this.groupApprovalIntarface.conector === '') {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			return false;
		} else {
			this.save();
		}
	}

	save(): void {
		if (this.groupApprovalIntarface.id) {
			// Se 'id' estiver definido, é uma atualização, então fazemos uma solicitação PUT
			this.ApproversGroupService.putGroupApproval(this.groupApprovalIntarface).subscribe((data) => {
				if (data[0].status === 'Error') {
					this.NotificationService.setNotificationMessage(this.labels.lbl_ja_possui_status_com_esse_nome);
				} else {
					this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
					this.clearInputs(true);
					this.getApproversGroup();
				}
			});
		} else {
			// Se 'id' for vazio, é uma nova entrada, então fazemos uma solicitação POST
			this.ApproversGroupService.postGroupApproval(this.groupApprovalIntarface).subscribe((data) => {
				if (data[0].status === 'Error') {
					this.NotificationService.setNotificationMessage(this.labels.lbl_ja_possui_status_com_esse_nome);
				} else {
					this.NotificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
					this.clearInputs(true);
					this.getApproversGroup();
				}
			});
		}
	}

	openForm(isNew: boolean): void {
		this.groupApprovalIntarface.group = '';
		this.groupApprovalIntarface.conector = '';
		this.showNewGroup = isNew;
	}

	onGroupApprovalChange(event: Event) {
		const selectedId = (event.target as HTMLSelectElement).value;
		if (selectedId) {
			this.ApproversGroupService.getAllGroupApprovals(selectedId).subscribe(
				(data: groupApprovalIntarface | groupApprovalIntarface[]) => {
					// Se a API retornar um array, pegue o primeiro elemento
					if (Array.isArray(data)) {
						data = data[0];
					}

					if (data) {
						this.groupApprovalIntarface.id = data.id;
						this.groupApprovalIntarface.group = data.group;
						this.groupApprovalIntarface.conector = data.conector;
					}
				},
				(error) => {
					console.error(error);
				}
			);
		}
	}
}
